define.alias("shared/components/shared/ui/video", "calendar/components/shared/ui/video");